{
  "list": {
    "title": "Expenses",
    "subtitle": "{{n}} expenses · Total {{total}}",
    "exportCsv": "Export CSV",
    "new": "New expense",
    "caption": "Expenses list",
    "emptyTitle": "No expenses",
    "emptyFiltered": "No matching results.",
    "emptyHint": "Record your first expense."
  },
  "filters": {
    "searchLabel": "Search descriptions",
    "searchPlaceholder": "Search descriptions",
    "type": "Type",
    "allTypes": "All types",
    "period": "Period",
    "allPeriods": "All periods",
    "thisMonth": "This month",
    "lastMonth": "Last month",
    "custom": "Custom range",
    "from": "From",
    "to": "To"
  },
  "columns": {
    "date": "Date",
    "type": "Type",
    "description": "Description",
    "amount": "Amount",
    "receipt": "Receipt",
    "createdBy": "Added by"
  },
  "row": {
    "viewReceipt": "View receipt {{name}}",
    "view": "View",
    "edit": "Edit expense",
    "delete": "Delete expense",
    "deleteTitle": "Delete expense",
    "deleteDescription": "The {{type}} expense of {{amount}} dated {{date}} will be deleted and excluded from totals.",
    "deleteConfirm": "Delete",
    "deleted": "Expense deleted"
  },
  "dialog": {
    "newTitle": "New expense",
    "editTitle": "Edit expense",
    "description": "Expenses are deducted from net fees to calculate net profit.",
    "receiptTitle": "Expense receipt"
  },
  "form": {
    "date": "Date",
    "amount": "Amount ({{currency}})",
    "type": "Expense type",
    "typePlaceholder": "Choose a type",
    "inactiveOption": "{{name}} (inactive)",
    "description": "Description",
    "optional": "Optional",
    "receipt": "Receipt",
    "removeReceipt": "Remove",
    "saving": "Saving…",
    "saveChanges": "Save changes",
    "submit": "Record expense",
    "saved": "Changes saved",
    "created": "Expense recorded",
    "typeInactive": "This type is inactive. Choose another type",
    "saveFailed": "Couldn't save"
  },
  "validation": {
    "dateRequired": "Date is required",
    "dateFuture": "The date can't be in the future",
    "typeRequired": "Choose an expense type",
    "amountPositive": "Enter an amount greater than zero",
    "descriptionMax": "Maximum 500 characters"
  }
}
